<template>
  <div class="px-6 py-2 breadcrumbs-container">
    <div class="d-flex align-center breadcrumbs-content">
      <div v-for="(item, index) in items" :key="index" class="d-flex align-center">
        <!-- Separator -->
        <span v-if="index > 0" class="mx-1 separator">
          <span class="mdi mdi-chevron-right size-20"></span>
        </span>

        <!-- Item -->
        <div class="breadcrumb-item">
          <app-badge v-if="item.active" :color="item.badgeColor || 'blue'">
            {{ item.title }}
          </app-badge>
          <span
              v-else
              :class="['label', { 'clickable': !!item.to || !!item.onClick }]"
              @click="handleClick(item)"
          >
            {{ item.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import AppBadge from "@/components/utils/ui_v4/feedback/AppBadge.vue";

const props = defineProps({
  items: {
    type: Array,
    required: true,
    default: () => []
  }
});

const emit = defineEmits(['click']);

const handleClick = (item) => {
  if (item.onClick) {
    item.onClick();
  }
  emit('click', item);
};
</script>

<style scoped>
.breadcrumbs-container {
  flex-shrink: 0;
  background: white;
  position: relative;
  z-index: 4;
}

.breadcrumbs-content {
  font-size: 14px;
}

.separator {
  color: #9e9e9e;
}

.label {
  color: #424242;
  text-decoration: none;
}

.label.clickable {
  cursor: pointer;
}

.label.clickable:hover {
  opacity: 0.8;
}
</style>
